var rich_content_viewer_default = {
  "fontElementMap": "tdDyL",
  "wrapper": "FhgRu",
  "pluginContainerMobile": "lIIid",
  "viewer": "RRncl",
  "android": "Aw12O",
  "rootedTraversedContent": "Pb7sq",
  "atomic": "hdCi5",
  "toolbar": "xAFWF",
  "block": "jSD-l"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
